import { TOrganizationDetailDto } from "@/api/services/admin/organization/dtos/get-organization-detail.dto";
import { DetailItem } from "@/components/elements/DetailItem";
import { SectionCard } from "@/components/elements/SectionCard";
import { EMPTY_STR } from "@/constants/string";
import { black } from "@/theme/colors";
import { Grid } from "@mui/material";
import { FC } from "react";

type Props = {
  organization: TOrganizationDetailDto;
};

export const OrganizationDetailOtherInfo: FC<Props> = ({ organization }) => {
  return (
    <SectionCard maxWidth="100%" title="その他情報（内部用）" titleVariant="head20Bold" titleColor={black[30]}>
      <Grid container spacing={3}>
        <Grid item xs={6}>
          <DetailItem label="顧客情報" value={organization.adminInfo ?? EMPTY_STR.TEXT} sx={{ whiteSpace: "pre-line" }} />
        </Grid>
        <Grid item xs={6}>
          <DetailItem label="内部メモ" value={organization.adminNotes ?? EMPTY_STR.TEXT} sx={{ whiteSpace: "pre-line" }} />
        </Grid>
      </Grid>
    </SectionCard>
  );
};
